import env from '@/config/env';
import BuscaHeader from '@/graphql/tabela/queries/BuscaHeader.gql';

export const Types = {
  LOADING: 'LOADING',
  SHOW: 'SHOW',
  SET_TYPE: 'SET_TYPE',
  SEARCH_CLEAR: 'SEARCH_CLEAR',
  SEARCH_DATA: 'SEARCH_DATA',
  TEXT_CLEAR: 'TEXT_CLEAR',
  TEXT_SET: 'TEXT_SET',
};

export default {
  namespaced: true,
  state: {
    loading: false,
    visible: false,
    type: 'smartphone', // Enum [smartphone, acessorios, ftw, pen_modem, roteador, netbook],
    text: '',
    data: [],
  },
  getters: {
    finderType: state => state.type,
    finderText: state => state.text,
    visible: state => state.visible,
    data: state => state.data,
  },
  mutations: {
    [Types.LOADING](state, payload) {
      state.loading = payload.loading;
    },
    [Types.SET_TYPE](state, payload) {
      state.type = payload.type;
    },
    [Types.TEXT_CLEAR](state) {
      state.text = '';
    },
    [Types.TEXT_SET](state, payload) {
      state.text = payload.text;
    },
    [Types.SEARCH_CLEAR](state) {
      state.data = [];
    },
    [Types.SEARCH_DATA](state, payload) {
      state.data = payload.data;
    },
    [Types.SHOW](state, payload) {
      state.visible = payload.visible;
    },
  },
  actions: {
    setType({ commit }, payload) {
      commit(Types.SEARCH_CLEAR);
      commit(Types.TEXT_CLEAR);
      commit(Types.SET_TYPE, { type: payload });
    },
    setText({ commit }, payload) {
      commit(Types.TEXT_CLEAR);
      commit(Types.TEXT_SET, { text: payload });
    },
    clearText({ commit }) {
      commit(Types.TEXT_CLEAR);
    },
    setVisible({ commit }, payload) {
      commit(Types.SHOW, { visible: payload });
    },
    async searchData({ commit, state, dispatch, rootGetters }, payload) {
      payload = payload.trim();
      if (payload.length <= 1) {
        // commit(Types.TEXT_CLEAR);
        commit(Types.SEARCH_CLEAR);
        dispatch('setVisible', false);
        return;
      }
      const tabela = await rootGetters['vcTabela/tabela'];
      const tipo = state.type;

      try {
        const query = await env.tabela.query({
          query: BuscaHeader,
          variables: {
            tabela,
            nome: payload,
            tipo,
            paginate: 40,
          },
          fetchPolicy: 'no-cache',
        });

        const { data } = query.data.search;
        commit(Types.SEARCH_DATA, { data });
        dispatch('setVisible', true);
      } catch (e) {
        console.log(e);
        dispatch(
          'error/setError',
          { message: 'Não foi possível buscar o que deseja.' },
          { root: true },
        );
      }
    },
    findData({ dispatch, state }) {
      if (state.data.length > 0 && !state.visible) {
        dispatch('setVisible', true);
      }
    },
  },
};
